import React from "react";
import { FormattedMessage } from "react-intl";
import messages from "./skip-to-section-messages";
import {
  MY_ACCOUNT_SECTION_ID,
  AFFILIATIONS_SECTION_ID,
  MERGE_ACCOUNTS_SECTION_ID
} from "../../../../constants";

import "./skip-to-section.scss";

const SkipToSection = props => {
  const setFocusOn = id => e => {
    e.preventDefault();
    const targetNode = document.getElementById(id);
    targetNode.focus();
  };

  return (
    <ul className="skip-to-section">
      <li className="skip-to-section__item">
        <a
          href={`#${MY_ACCOUNT_SECTION_ID}`}
          className="skip-to-section__link"
          onClick={setFocusOn(MY_ACCOUNT_SECTION_ID)}
        >
          <FormattedMessage {...messages.myAccount} />
        </a>
      </li>
      <li className="skip-to-section__item">
        <a
          href={`#${AFFILIATIONS_SECTION_ID}`}
          className="skip-to-section__link"
          onClick={setFocusOn(AFFILIATIONS_SECTION_ID)}
        >
          <FormattedMessage {...messages.affiliations} />
        </a>
      </li>
      <li className="skip-to-section__item">
        <a
          href={`#${MERGE_ACCOUNTS_SECTION_ID}`}
          className="skip-to-section__link"
          onClick={setFocusOn(MERGE_ACCOUNTS_SECTION_ID)}
        >
          <FormattedMessage {...messages.mergeAccounts} />
        </a>
      </li>
    </ul>
  );
};

export default SkipToSection;
